class Grid {
  constuctor(row, col) {
    this.row = row;
    this.col = col;
  }

  print() {
    console.log("row: %d, col: %d", row, col);
  }

  static get MAX_COLS() {
    return Grid.AREA.width / Grid.SIZE.width;
  }

  static get MAX_ROWS() {
    return Grid.AREA.height / Grid.SIZE.height;
  }

  static get AREA() {
    return {
      width: 1000,
      height: 1000
    };
  }

  static get SIZE() {
    return {
      width: 20,
      height: 20
    };
  }

  /**
   * convert id to [row, col]
   * @param  {[type]} id [description]
   * @return {[type]}    [description]
   */
  static rowCol(id) {
    let row = Math.ceil(id / Grid.MAX_ROWS);
    let col = id % Grid.MAX_COLS;
    if (col == 0) {
      col = 50;
    }
    return {
      row: row,
      col: col
    };
  }

  /**
   * convert row, col to id
   * @param  {[type]} row [description]
   * @param  {[type]} col [description]
   * @return {Integer}     grid ID
   */
  static id(row, col) {
    return row * Grid.MAX_COLS + col + 1;
  }

  static positionToId(position) {
    let col = Math.floor(position.x / Grid.SIZE.width);
    let row = Math.floor(position.y / Grid.SIZE.height);
    return Grid.id(row, col);
  }

  static rectById(id) {
    const rowCol = Grid.rowCol(id);
    return {
      x: (rowCol.col - 1) * 20,
      y: (rowCol.row - 1) * 20,
      width: Grid.SIZE.width,
      height: Grid.SIZE.height
    };
  }
}

module.exports = Grid;
